import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import moment from "moment";

import Loading from "@/components/Loading";
import Page from "@/components/Page";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";
import ViewField from "@/components/Input/ViewField";
import VLFModal from "@/components/Modal";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {MedicalAPI} from "@/api/medical";

import {ERROR_OPERATION, SUCCESSFUL_OPERATION} from "@/utils/constants";
import {isDateValid} from "@/utils/functions";

function InjuryPage(props) {
	const {handleNotification} = props;
	const location = useLocation();
	const navigate = useNavigate();
	const {recordId, id} = useParams();

	const [loading, setLoading] = useState(false);
	const [openHandleConfirm, setOpenHandleConfirm] = useState(false);
	const [injury, setInjury] = useState({});
	const [type, setType] = useState("");

	useEffect(() => {
		if (location) {
			setType(location.state.recordType === false ? "injury" : "illness");
			setInjury(location.state);
		}
	}, [location]);

	const deleteInjury = async () => {
		setLoading(true);
		try {
			await MedicalAPI.injuryDelete(recordId, id);
			handleNotification(SUCCESSFUL_OPERATION, "success");
			navigate("/medical/records/" + recordId);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
			setLoading(false);
		} finally {
			setOpenHandleConfirm(false);
		}
	};

	const injuryTypeConfiguration = [
		{
			value: injury?.startDate
				? moment(injury?.startDate).format("DD/MM/YYYY")
				: "---",
			label: "Inizio",
			size: "col-12 col-lg-6",
		},
		{
			value: isDateValid(injury?.endDate)
				? moment(injury?.endDate).format("DD/MM/YYYY")
				: "---",
			label: "Fine",
			size: "col-12 col-lg-6",
		},
		{value: injury?.diagnosis, label: "Diagnosi", size: "col-12 col-lg-6"},
		{value: injury?.cause, label: "Causa", size: "col-12 col-lg-6"},
		{
			value: injury?.injuryType,
			label: "Tipologia infortunio",
			size: "col-12 col-lg-6",
		},
		{
			value: injury?.bodyPart,
			label: "Parte del corpo",
			size: "col-12 col-lg-6",
		},
		{
			value: injury?.medicalDischargeDate
				? moment(injury?.medicalDischargeDate).format("DD/MM/YYYY")
				: "---",
			label: "Dimissione medica",
			size: "col-12 col-lg-6",
		},
		{
			value: injury?.sportsDischargeDate
				? moment(injury?.sportsDischargeDate).format("DD/MM/YYYY")
				: "---",
			label: "Dimissione sportiva",
			size: "col-12 col-lg-6",
		},
		{value: injury?.exam, label: "Esame", size: "col-12 col-lg-6"},
		{value: injury?.therapy, label: "Terapia", size: "col-12 col-lg-6"},
		{value: injury?.notes, label: "notes", size: "col-12 col-lg-6"},
	];

	const illnessTypeConfiguration = [
		{value: injury?.diagnosis, label: "Diagnosi", size: "col-12 col-lg-6"},
		{
			value: injury?.medicalDischargeDate
				? moment(injury?.medicalDischargeDate).format("DD/MM/YYYY")
				: "---",
			label: "Dimissione medica",
			size: "col-12 col-lg-6",
		},
		{
			value: injury?.sportsDischargeDate
				? moment(injury?.sportsDischargeDate).format("DD/MM/YYYY")
				: "---",
			label: "Dimissione sportiva",
			size: "col-12 col-lg-6",
		},
		{value: injury?.exam, label: "Esame", size: "col-12 col-lg-6"},
		{value: injury?.therapy, label: "Terapia", size: "col-12 col-lg-6"},
		{value: injury?.notes, label: "notes", size: "col-12 col-lg-6"},
	];

	const mainActions = [
		{
			icon: <ArrowBackIcon />,
			title: "Indietro",
			onClick: () => navigate(-1),
			color: "info",
		},
		{
			icon: <EditIcon />,
			title: "Modifica",
			onClick: () =>
				navigate("/medical/records/" + recordId + "/injuries/" + id + "/edit", {
					state: location.state,
				}),
		},
		{
			icon: <DeleteIcon />,
			title: "Elimina",
			onClick: () => setOpenHandleConfirm(true),
			color: "error",
		},
	];

	const breadcrumbsElements = [
		{label: "Passaporti medici", path: "/medical/records"},
		{label: "/"},
		{
			label: location?.state
				? (location.state.playerData?.firstName || "") +
					" " +
					(location.state.playerData?.lastName || "")
				: "",
			path: "/medical/records/" + recordId,
		},
	];

	return (
		<Page className="page-container">
			<Loading visible={loading} />
			<Breadcrumbs
				elements={breadcrumbsElements}
				actions={<MainActions actions={mainActions} />}
			/>
			<div className="row no-margin">
				<div className="col-sm-12 padding-small">
					<VLFCard
						title="Informazioni principali"
						content={
							<div className="row">
								<div className="col-sm-12">
									<ViewField
										configuration={
											type === "injury"
												? injuryTypeConfiguration
												: illnessTypeConfiguration
										}
									/>
								</div>
							</div>
						}
						openable={false}
					/>
				</div>
			</div>
			<VLFModal
				open={openHandleConfirm}
				title="Eliminazione"
				content={
					<div className="mt-2">
						Sei sicuro di voler eliminare questo elemento?
					</div>
				}
				confirm={deleteInjury}
				close={() => setOpenHandleConfirm(false)}
				confirmLabel="Conferma"
			/>
		</Page>
	);
}

export default InjuryPage;
